<template>
  <div class="car-archive">
    <div class="search-warehouse">
      <div class="screen">
        <el-input class="white w200" v-model="search.batchNo" placeholder="请输入批次号"></el-input>
        <el-select class="white w200" 
            clearable
            v-model="search.brandId" 
            placeholder="请选择品牌" 
            filterable 
            v-lazy-load-dropdown="handleScrollDropdown">
          <el-option
            v-for="item in brandTypeOptionsList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-date-picker
          class="white w200"
          v-model="search.arrivalDate"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd">
        </el-date-picker>
        <el-button class="btn-blue" @click="onSearch">搜索</el-button>
      </div>
    </div>
    <div class="table">
      <el-table ref="table" :data="kanbanList" style="width: 100%">
        <el-table-column 
          v-for="(item, index) in tableTitleList"
          :key="index"
          :label="item.label"
          :prop="item.prop"
          :min-width="item.width"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button class="btn-text" type="text" @click="lookDetails(scope.row)">详情</el-button>
            <!-- <el-button class="btn-text" type="text" @click="exportData(scope.row)">导出</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer">
      <pagination-tpl
        :total="total"
        :currentPage="currentPage"
        :pageSize="pageSize"
        @queryChange="queryChange"
      ></pagination-tpl>
    </div>
  </div>
</template>

<script>
import { modifyNetTitle } from "common/js/util";
import PaginationTpl from "components/base/PaginationTpl";
import BrandMixins from "common/mixins/smart-vehicle-inspection/brand";
import SmartVehicleInspection from "models/smart-vehicle-inspection/smart-vehicle-inspection";
export default {
  mixins: [BrandMixins],
  data() {
    return {
      search: {
        batchNo: '',
        brandId: '',
        arrivalDate: ''
      },
      brancdList: [],
      kanbanList: [],
      tableTitleList: [
        {label: '批次号', prop: 'batchNo', width: '140'},
        {label: '品牌', prop: 'brandName'},
        {label: '采集模板', prop: 'templateName'},
        {label: '计划采集车辆', prop: 'planCount'},
        {label: '已采集', prop: 'collectedCount'},
        {label: '未采集', prop: 'uncollectedCount'},
        {label: '导出状态', prop: 'exportStatusVal'},
        {label: '到港时间', prop: 'arrivalDate'},
        {label: '作业类型', prop: 'assignmentTypeVal'}
      ],
      total: 0,
      currentPage: 1,
      pageSize: 20
    };
  },
  components: {
    PaginationTpl
  },
  created() {
    modifyNetTitle('采集看板')
    this.initKanbanList();
    this.initBrandList();
  },
  methods: { 
    initKanbanList() {
      let data = this.search
      data.pageNo = this.currentPage
      data.pageSize = this.pageSize
      SmartVehicleInspection.getBatchList(data).then(res => {
        if (res.success) {
          const { records, total, size } = res.result
          this.pageSize = size;
          this.total = total;
          let arr = [];
          records.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.batchNo = value.batchNo;
            obj.brandName = value.brandName;
            obj.templateName = value.templateName;
            obj.planCount = value.planCount;
            obj.collectedCount = value.collectedCount;
            obj.uncollectedCount = value.uncollectedCount;
            obj.arrivalDate = value.arrivalDate;
            obj.jobType = value.jobType;
            obj.assignmentTypeVal = value.jobType === 1?'接收检验':'移交检验';
            obj.exportStatus = value.exportStatus;
            obj.exportStatusVal = value.exportStatus === 0?'未导出':'已导出';
            arr.push(obj);
          });
          this.kanbanList = arr;
        }
      })
    },

    //翻页
    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initKanbanList();
    },

    onSearch() {
      this.initKanbanList()
    },

    lookDetails(row) {
      this.$router.push({
        path: '/vehicle/homework-center/kanban/kanban-details',
        query: {
          id: row.id,
          batchNo: row.batchNo,
          brandName: row.brandName,
          assignmentTypeVal: row.assignmentTypeVal,
        }
      })
    },
    
    // // 导出表格
    // exportData() {
    //   if (this.tableData.length > 0) {
    //     let data = this.search
    //     data.pageNo = this.currentPage
    //     data.pageSize = this.pageSize
    //     SmartVehicleInspection.getExportExcel(date).then(res => {
    //       let blob = new Blob([res.data], { type: res.headers.contentType });
    //       let fileName = window.decodeURI(
    //         res.headers["content-disposition"].split("=")[1]
    //       );
    //       var url = URL.createObjectURL(blob);
    //       var a = document.createElement("a");
    //       a.href = url;
    //       a.download = fileName;
    //       a.click();
    //       // 释放之前创建的URL对象
    //       window.URL.revokeObjectURL(url);
    //     });
    //   } else {
    //     this.$message.error("搜索数据为空，请重新搜索");
    //   }
    // },
  }
};
</script>
<style lang="scss" scoped>
.car-archive {
  flex: 1;
  background: #fff;
  border-radius: 4px;
  padding: 16px;
  box-sizing: border-box;
  .search-warehouse {
    margin-bottom: 16px;
    .screen {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .w200 {
        width: 200px;
        margin-right: 16px;
      }
    }
  }
  
  .footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 16px;
  }
}
</style>
